import { ActivityStatus } from './ActivityItem';

/**
 * Formats timestamp as relative time
 */
export function formatTimestamp(
  timestamp: Date,
  status: ActivityStatus,
  currentTime?: Date
): string {
  const relativeTime = (() => {
    const now = currentTime || new Date();
    const diffMs = now.getTime() - timestamp.getTime();
    const diffMinutes = Math.max(0, Math.floor(diffMs / (1000 * 60)));
    const diffHours = Math.floor(diffMinutes / 60);

    const startOfToday = new Date(
      now.getFullYear(),
      now.getMonth(),
      now.getDate()
    );
    const startOfTimestamp = new Date(
      timestamp.getFullYear(),
      timestamp.getMonth(),
      timestamp.getDate()
    );
    const diffDays = Math.floor(
      (startOfToday.getTime() - startOfTimestamp.getTime()) /
        (1000 * 60 * 60 * 24)
    );

    if (diffDays === 0) {
      if (diffMinutes < 1) {
        return 'Just now';
      }

      if (diffMinutes < 60) {
        return `${diffMinutes} minute${diffMinutes !== 1 ? 's' : ''} ago`;
      }

      return `${diffHours} hour${diffHours !== 1 ? 's' : ''} ago`;
    }

    if (diffDays === 1) return 'Yesterday';
    return `${diffDays} days ago`;
  })();

  if (status === 'inProgress') {
    return `Initiated ${relativeTime.toLowerCase()}`;
  }

  return relativeTime;
}
